

export const FETCH_MEDIA_REQUEST = 'FETCH_MEDIA_REQUEST';
export const FETCH_MEDIA_SUCCESS = 'FETCH_MEDIA_SUCCESS';
export const FETCH_MEDIA_FAILURE = 'FETCH_MEDIA_FAILURE';

export const fetchMediaRequest = () => {
  return{
    type: FETCH_MEDIA_REQUEST
  };
};

export const fetchMediaSuccess = media => {
  return {
    type: FETCH_MEDIA_SUCCESS,
    media
  };
};
export const fetchMediaFailure = error => {
  return {
    type: FETCH_MEDIA_FAILURE,
    error
  };
};

export const fetchMedia = () => {
  return dispatch => {
    dispatch(fetchMediaRequest());

    return fetch(`${apiBase}/wp/v2/media?per_page=100`)
      .then(response => response.json())
      .then(json => dispatch(fetchMediaSuccess(json)));
  };
};

export const FETCH_MEDIA_ITEM_REQUEST = 'FETCH_MEDIA_ITEM_REQUEST';
export const FETCH_MEDIA_ITEM_SUCCESS = 'FETCH_MEDIA_ITEM_SUCCESS';
export const FETCH_MEDIA_ITEM_FAILURE = 'FETCH_MEDIA_ITEM_FAILURE';

export const fetchMediaItemRequest = () => {
  return{
    type: FETCH_MEDIA_ITEM_REQUEST
  };
};

export const fetchMediaItemSuccess = mediaItem => {
  return {
    type: FETCH_MEDIA_ITEM_SUCCESS,
    mediaItem
  };
};
export const fetchMediaItemFailure = error => {
  return {
    type: FETCH_MEDIA_ITEM_FAILURE,
    error
  };
};

export const fetchMediaItem = id => {
  return dispatch => {
    dispatch(fetchMediaItemRequest());

    return fetch(`${apiBase}/wp/v2/media/${id}`)
      .then(response => response.json())
      .then(json => dispatch(fetchMediaItemSuccess(json)));
  };
};
